import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { CartProvider } from "@/contexts/CartContext";
import { WishlistProvider } from "@/contexts/WishlistContext";
import { CompareProvider } from "@/contexts/CompareContext";
import { CartDrawer } from "@/components/shop/CartDrawer";
import { WishlistDrawer } from "@/components/shop/WishlistDrawer";
import { CompareModal } from "@/components/shop/CompareModal";
import { FlyingCartAnimation } from "@/components/shop/FlyingCartAnimation";
import { AnimatedRoutes } from "@/components/layout/AnimatedRoutes";
import { CookieConsent } from "@/components/common/CookieConsent";
import { ErrorBoundary } from "@/components/common/ErrorBoundary";
import { SkipToContent } from "@/components/common/SkipToContent";
import { GoogleAnalytics } from "@/components/analytics/GoogleAnalytics";
import { StructuredData, organizationSchema, websiteSchema } from "@/components/seo/StructuredData";

const queryClient = new QueryClient();

const App = () => (
  <ErrorBoundary>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <CartProvider>
          <WishlistProvider>
            <CompareProvider>
              <TooltipProvider>
                <Toaster />
                <Sonner />
                <CartDrawer />
                <WishlistDrawer />
                <CompareModal />
                <FlyingCartAnimation />
                <BrowserRouter>
                  <StructuredData schemas={[organizationSchema, websiteSchema]} />
                  <GoogleAnalytics />
                  <SkipToContent />
                  <AnimatedRoutes />
                  <CookieConsent />
                </BrowserRouter>
              </TooltipProvider>
            </CompareProvider>
          </WishlistProvider>
        </CartProvider>
      </QueryClientProvider>
    </HelmetProvider>
  </ErrorBoundary>
);

export default App;
